import React from 'react';

import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onClearSelection, onBulkPriceUpdate, onBulkCategoryChange, onBulkDelete }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 animate-scale-in">
      <div className="bg-card border border-border rounded-2xl shadow-2xl px-4 md:px-6 py-3 md:py-4 flex items-center gap-3 md:gap-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
            <span className="text-sm font-caption font-bold text-primary">{selectedCount}</span>
          </div>
          <span className="text-sm md:text-base font-caption text-foreground">
            {selectedCount} selected
          </span>
        </div>

        <div className="h-6 w-px bg-border" />

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="DollarSign"
            iconPosition="left"
            iconSize={16}
            onClick={onBulkPriceUpdate}
            className="hidden sm:flex"
          >
            Update Price
          </Button>

          <Button
            variant="ghost"
            size="sm"
            iconName="FolderOpen"
            iconPosition="left"
            iconSize={16}
            onClick={onBulkCategoryChange}
            className="hidden sm:flex"
          >
            Change Category
          </Button>

          <Button
            variant="ghost"
            size="icon"
            iconName="DollarSign"
            iconSize={18}
            onClick={onBulkPriceUpdate}
            className="sm:hidden"
          />

          <Button
            variant="ghost"
            size="icon"
            iconName="FolderOpen"
            iconSize={18}
            onClick={onBulkCategoryChange}
            className="sm:hidden"
          />

          <Button
            variant="ghost"
            size="icon"
            iconName="Trash2"
            iconSize={18}
            onClick={onBulkDelete}
            className="hover:bg-error/10 hover:text-error"
          />

          <Button
            variant="outline"
            size="sm"
            iconName="X"
            iconPosition="left"
            iconSize={16}
            onClick={onClearSelection}
          >
            Clear
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;